// extracted by mini-css-extract-plugin
export var statItem = "_lo-1";
export var statsRow = "_lo-0";